import {
  Action,
  LIST_LOADING,
  LIST_RECEIVED,
  LIST_ERROR_RECEIVED,
  DETAIL_REMOVE_SUCCESS,
  SHARING_SUCCESS,
  PROJECT_FILTER,
  SHARING_MODAL_OPEN,
  SHARING_DATASET_PENDING,
  SHARING_ERROR,
  updateDatasetCommunityVisibilityError,
  updateDatasetCommunityVisibilityPending,
  updateDatasetCommunityVisibilitySuccess,
  LIST_ITEM_UPDATE_SUCCESS,
} from '../Actions/UserDatasetsActions';

import { DatasetListEntry } from '../Service';
import { CommunityPromotionError } from '../Components/Sharing/CommunityPromotionError';

export const key = 'userDatasetList';

type SharingModalState = {
  sharingModalOpen: boolean;
  sharingDatasetPending: boolean;
  shareError: Error | undefined;
  shareSuccessful: boolean | undefined;
  updateDatasetCommunityVisibilityPending: boolean;
  updateDatasetCommunityVisibilitySuccess: boolean;
  updateDatasetCommunityVisibilityError: undefined | CommunityPromotionError;
};

type InitialState = SharingModalState & {
  status: 'not-requested';
};

type LoadingState = SharingModalState & {
  status: 'loading';
};

type ErrorState = SharingModalState & {
  status: 'error';
  loadError: Error;
};

type ForbiddenState = SharingModalState & {
  status: 'forbidden';
  loadError: Error;
};

type CompleteState = SharingModalState & {
  status: 'complete';
  userDatasets: Array<DatasetListEntry>;
  filterByProject: boolean;
};

export type State =
  | InitialState
  | LoadingState
  | ErrorState
  | ForbiddenState
  | CompleteState;

const initialState: State = {
  status: 'not-requested',
  sharingModalOpen: false,
  sharingDatasetPending: false,
  shareError: undefined,
  shareSuccessful: undefined,
  updateDatasetCommunityVisibilityPending: false,
  updateDatasetCommunityVisibilitySuccess: false,
  updateDatasetCommunityVisibilityError: undefined,
};

export function reduce(state: State = initialState, action: Action): State {
  switch (action.type) {
    case LIST_LOADING:
      return {
        ...state,
        status: 'loading',
      };

    case LIST_RECEIVED:
      return {
        ...state,
        status: 'complete',
        filterByProject: action.payload.filterByProject,
        userDatasets: action.payload.userDatasets,
      };

    case LIST_ERROR_RECEIVED:
      return action.payload.error.statusCode === 403
        ? {
            ...state,
            status: 'forbidden',
            loadError: action.payload.error,
          }
        : {
            ...state,
            status: 'error',
            loadError: action.payload.error,
          };

    case LIST_ITEM_UPDATE_SUCCESS:
      return state.status === 'complete'
        ? {
            ...state,
            // replace the old dataset list object with the updated one.
            userDatasets: state.userDatasets.map((it) =>
              it.datasetId === action.payload.userDataset.datasetId
                ? action.payload.userDataset
                : it
            ),
          }
        : state;

    case DETAIL_REMOVE_SUCCESS:
      return state.status === 'complete'
        ? {
            ...state,
            userDatasets: state.userDatasets.filter(
              (it) => it.datasetId !== action.payload.datasetId
            ),
          }
        : state;

    case SHARING_SUCCESS:
      return {
        ...state,
        sharingDatasetPending: false,
        shareSuccessful: action.payload.shareSuccessful,
      };

    case SHARING_MODAL_OPEN:
      return {
        ...state,
        sharingModalOpen: action.payload.sharingModalOpen,
      };

    case SHARING_DATASET_PENDING:
      return {
        ...state,
        sharingDatasetPending: action.payload.sharingDatasetPending,
      };

    case SHARING_ERROR:
      return {
        ...state,
        sharingDatasetPending: false,
        shareError: action.payload.shareError,
      };

    case PROJECT_FILTER: {
      if (state.status === 'complete') {
        return {
          ...state,
          filterByProject: action.payload.filterByProject,
        } as CompleteState;
      }
      return state;
    }

    case updateDatasetCommunityVisibilityError.type:
      return {
        ...state,
        updateDatasetCommunityVisibilityPending: false,
        updateDatasetCommunityVisibilityError: action.payload.errorMessage,
      };
    case updateDatasetCommunityVisibilityPending.type:
      return {
        ...state,
        updateDatasetCommunityVisibilityPending: true,
      };
    case updateDatasetCommunityVisibilitySuccess.type:
      return {
        ...state,
        updateDatasetCommunityVisibilityPending: false,
        updateDatasetCommunityVisibilitySuccess: action.payload.success ?? true,
      };

    default:
      return state;
  }
}
